import { SortDir } from '@ui/src';

export const productRiskListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Product / Service',
  },
  {
    name: 'riskScore',
    label: 'Risk Score',
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
  {
    name: 'updatedAt',
    label: 'Date updated',
  },
];

export const productRiskListDefaultSorter = {
  sortProp: productRiskListColumns[1].name,
  sortDir: SortDir.ASC,
};

export const productRiskListSchema = {};

export const productRiskListFiltersSchema = [];
